<template>
  <div :style="cssVariablesBinding">
    <Theme6BaseTheHeader />

    <div v-if="shouldShowComponent" id="msgboxxWidget" />
    <a
      v-if="company.company_key === 'harrisonshomes'"
      href="https://wa.me/447741066215?text=Hi%2C%20I%27d%20like%20to%20chat%20about%20your%20services."
      target="_blank"
      rel="noopener"
      aria-label="Chat with us on WhatsApp"
      class="whatsapp-float"
    >
      <svg width="24" height="24" viewBox="0 0 32 32" aria-hidden="true">
        <path
          fill="#fff"
          d="M19.11 17.42c-.27-.13-1.58-.78-1.82-.87s-.42-.13-.6.13-.69.87-.85 1.05-.31.2-.58.07a7.63 7.63 0 0 1-2.24-1.38 8.41 8.41 0 0 1-1.56-1.93c-.16-.27 0-.42.12-.55s.27-.31.4-.49.2-.27.31-.45a.5.5 0 0 0 0-.49c0-.14-.6-1.45-.82-1.99s-.42-.46-.6-.46h-.51a1 1 0 0 0-.73.36 3.05 3.05 0 0 0-.96 2.27 5.31 5.31 0 0 0 1.1 2.87c.13.18 1.82 2.78 4.41 3.9a14.96 14.96 0 0 0 1.48.55 3.57 3.57 0 0 0 1.64.1 2.68 2.68 0 0 0 1.75-1.23 2.19 2.19 0 0 0 .16-1.23c-.07-.11-.25-.18-.52-.31z"
        />
        <path
          fill="#fff"
          d="M16 3a12.93 12.93 0 0 0-11 19.6L4 29l6.6-1A13 13 0 1 0 16 3zm0 23.6a10.6 10.6 0 0 1-5.39-1.48l-.39-.23-3.82.62.65-3.73-.25-.39A10.6 10.6 0 1 1 16 26.6z"
        />
      </svg>
    </a>

    <main class="n-main-container">
      <slot />
    </main>

    <Theme6BaseTheFooter />
  </div>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import IndexGlobal from '~/mixins/index.global';
import LayoutsMixin from '~/mixins/layouts.mixin';
import { useWebsiteStore } from '~/units/website/store';
import AvailableComponentsForTheme6 from '~/components/theme6/AvailableComponentsForTheme6.vue';
import { useAppMode } from '~/composables';

export default defineNuxtComponent({
  name: 'Theme6',

  mixins: [IndexGlobal, LayoutsMixin],

  components: { AvailableComponentsForTheme6 },

  data() {
    return {
      containers: [
        {
          name: 'BLOGS_VIEW',
          classes: 'blog-wrap5',
        },
        {
          name: 'BLOG_DETAIL_VIEW',
          classes: 'blog-wrap6',
        },
      ],
    };
  },

  head(context) {
    const appMode = useAppMode();

    if (appMode.server && context.ssrContext) {
      const websiteStore = useWebsiteStore();
      const isNicholsons = websiteStore.companyKey === 'nicholsonsestateagents';

      const tagScripts = (() => {
        if (process.env.APP_STAGE === 'production') {
          return [
            ...websiteStore.googleTagsScripts,
            {
              key: 'company-analytics',
              type: 'text/javascript',
              src: `/theme6/js/${websiteStore.companyKey}.js`,
              async: false,
            },
          ];
        }
        return [];
      })();

      return {
        link: [
          {
            rel: 'stylesheet',
            href: `/theme6/css/${websiteStore.companyKey}/${websiteStore.companyKey}.css`,
            type: 'text/css',
            fetchPriority: 'low',
          },
          {
            rel: 'stylesheet',
            href: `/theme6/css/animate.min.css`,
            type: 'text/css',
          },
          {
            rel: 'stylesheet',
            href: `/theme6/css/odometer.css`,
            type: 'text/css',
          },
          isNicholsons
            ? {
                rel: 'stylesheet',
                href: 'https://cdn.msgboxx.io/static/css/bundle.min.css',
                type: 'text/css',
              }
            : null,
        ],
        script: [
          ...tagScripts,
          isNicholsons
            ? {
                src: 'https://cdn.msgboxx.io/static/js/bundle.min.js',
                async: true,
                onload: "window.msgboxxClient='NICHOLSONS';",
                body: true,
              }
            : null,

          isNicholsons
            ? {
                src: `https://assets.calendly.com/assets/external/widget.js`,
                type: 'text/javascript',
                async: true,
              }
            : null,
          {
            src: `/theme6/js/vendor/jquery-3.6.0.min.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme6/js/jarallax.min.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme6/js/jarallax-video.min.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme6/js/jquery.odometer.min.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme6/js/jquery.appear.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme6/js/jquery.easing.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme6/js/slick.min.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme6/js/slick-animation.min.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme6/js/magnific-popup.min.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme6/js/ajax-form.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme6/js/wow.min.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme6/js/main.js`,
            type: 'text/javascript',
            async: false,
          },
        ],
      };
    }
  },

  computed: {
    ...mapState(useWebsiteStore, ['currentPage']),

    cssVariablesBinding() {
      return {
        ...this.cssVariables,
        '--c-primary': this.colors.primary || '#000000',

        '--akya-text-color': 'var(--c-text-primary)',
        '--akya-background-color': 'var(--c-section_primary)',
        '--akya-confirm-button-text-color': 'var(--c-text-secondary)',
        '--akya-confirm-button-background-color': 'var(--c-primary)',
      };
    },

    isNicholsons() {
      return useWebsiteStore().companyKey === 'nicholsonsestateagents';
    },

    shouldShowComponent() {
      const currentPath = this.$route.path;
      const isInHeadsUpAlerts = currentPath.startsWith('/heads-up-alerts');
      return this.isNicholsons && !isInHeadsUpAlerts;
    },
  },
});
</script>
